<script setup lang="ts">
  import { computed } from 'vue';

  import { Priority } from '@stuut/common/src/constants';
  import { Tooltip, TooltipContent, TooltipTrigger } from '@ui/components/tooltip';

  interface Props {
    priority?: Priority;
    size?: '2xs' | 'xs' | 'sm';
  }

  const props = withDefaults(defineProps<Props>(), {
    priority: Priority.LOW,
    size: 'sm',
  });

  const PriorityColor = {
    [Priority.HIGH]: 'text-red-500',
    [Priority.LOW]: 'text-muted-foreground',
    [Priority.MEDIUM]: 'text-warning',
    [Priority.URGENT]: 'text-red-700',
  };

  const PrioritySize = {
    '2xs': 'text-[6px]!',
    sm: '!text-3xs',
    xs: '!text-4xs',
  };

  const colorClass = computed(() => PriorityColor[props.priority]);
  const sizeClass = computed(() => PrioritySize[props.size]);
</script>

<template>
  <Tooltip>
    <TooltipTrigger as-child>
      <i class="fa-solid fa-circle block" :class="[colorClass, sizeClass]" />
    </TooltipTrigger>

    <TooltipContent class="text-2xs first-letter:uppercase">
      {{ priority }} priority
    </TooltipContent>
  </Tooltip>
</template>

<style scoped></style>
